import styled from 'styled-components'
import { Select } from 'antd'

export const StyledSelect = styled<any>(Select)`
  width: 80px;
  position: absolute;
  z-index: 1;
`
